export default __webpack_public_path__ + "static/media/downloadBlack.34152300.svg";